module.exports = __webpack_public_path__ + "html/analysis.component.html";